import React, { useEffect, useState } from "react"
import WPApiFetch from '../Utility/WPApi'
import { ParseHtml } from "../Utility/WPParser";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getBaseURL } from '../Utility/getBaseURL'

import "./MailchimpForm.scss";

const MailchimpForm = () => {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [labelVisible, setLabelVisible] = useState(true);
	const [nonce, setNonce] = useState();
	const [formResponse, setFormResponse] = useState();
	const formUrl = getBaseURL() + '/wp-json/bos/v1/mc';
	useEffect(() => {
	    async function fetchNonce() {
		   	const route = '/bos/v1/mc/nonce'; //?rand='+Math.random()
			const data = await WPApiFetch(route, null, 'GET', null, 'omit');
			setNonce(data.nonce);
	    }
	    fetchNonce();
	}, [])
	const handleSubmit = async ev => {
		ev.preventDefault();
		//const theForm = ev.target;
		const formElements = ev.target.elements;
		const formData = new FormData();
		await executeRecaptcha('token');
		[...formElements].map(item => {
			switch(item.type) {
				case 'fieldset':
					break;
				case 'radio':
				case 'checkbox':
					if(item.checked) {
						formData.append(item.name, item.value);
					}
					break;
				default: 
					formData.append(item.name, item.value);
					break;
			}
			return null;
		})
		fetch(formUrl, { method: 'post', headers: {}, credentials:"omit", body: formData } )
			.then(async response => {
				const data = await response.text();
				setFormResponse(data);
	  		}).catch( error => { return Promise.reject(error); });
	}
	const handleChange = (ev) => {
		setLabelVisible( (ev.target.value.length > 0 ) ? false : true )
	}
	return (
		<div id="mc_signup">
			<form method="post" action="#mc_signup" id="mc_signup_form" onSubmit={handleSubmit}>
				<input type="hidden" id="mc_submit_type" name="mc_submit_type" value="js" />
				<input type="hidden" name="mcsf_action" value="mc_submit_signup_form" />
				<input type="hidden" id="_mc_submit_signup_form_nonce" name="_mc_submit_signup_form_nonce" defaultValue={nonce} />
				<div id="mc_subheader">Stay up to date on our latest releases &amp; giveaways</div>
				<div className="mc_form_inside">
					<div id="mc_message">{formResponse && ParseHtml(formResponse)}</div>
					<div className="mc_merge_var">
						{labelVisible && <label htmlFor="mc_mv_EMAIL" className="mc_var_label mc_header mc_header_email">Email Address</label>}
						<input type="text" size="18" placeholder="" name="mc_mv_EMAIL" id="mc_mv_EMAIL" className="mc_input" onChange={handleChange} />
					</div>
					<div className="mc_signup_submit">
						<input type="submit" name="mc_signup_submit" id="mc_signup_submit" value="Subscribe" className="button" />
					</div>
				</div>
			</form>
		</div>
	)
}
export default MailchimpForm